import { render, staticRenderFns } from "./team-member.vue?vue&type=template&id=b2a09938&scoped=true&"
import script from "./team-member.vue?vue&type=script&lang=js&"
export * from "./team-member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a09938",
  null
  
)

export default component.exports